import { jsx as i, jsxs as L } from "react/jsx-runtime";
import { enUS as A } from "../../node_modules/date-fns/locale/en-US.mjs";
import { useState as h, useRef as E, useEffect as F } from "react";
import { DatePicker as R } from "../../node_modules/react-datepicker/dist/index.es.mjs";
import { TimeFormatEnum as s } from "../../enums/date-time-format/index.mjs";
import { ButtonInput as W } from "./components/button-Input.mjs";
import { transformSioDateFormatToDatePicker as B } from "./utills/transform-sio-date-format-to-date-picker.mjs";
import { DatePickerHeader as U } from "./components/date-picker-header.mjs";
import { useDateFnsLocale as $ } from "./hooks/use-date-fns-locale.mjs";
import { useTranslation as G } from "../../i18n.mjs";
import { setDateWithTimezone as c, toISOStringWithoutTimezone as J } from "../../utils/date-time-format.mjs";
import { flip as K, shift as Q } from "../../node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs";
import { PrimaryButton as V } from "../button/components/primary-button/index.mjs";
import { DangerButton as X } from "../button/components/danger-button/index.mjs";
const ce = ({
  value: o,
  onChange: g,
  error: x,
  label: y,
  required: D,
  placeholder: S,
  description: k,
  customProps: _,
  wrapperButtonInputClassName: w,
  labelClassName: C,
  timezone: n,
  intlLocale: p,
  disableApplyButton: d,
  userTimeFormat: a,
  userDateFormat: b
}) => {
  const { t: m } = G(), [t, l] = h(
    o && c(o, n) || null
  ), [r, u] = h(
    o && c(o, n) || null
  ), [P, M] = h(A), f = E(null);
  F(() => {
    o && !t && !r && n && (l(c(o, n)), u(c(o, n)));
  }, [o, n, t, r]), $(p, M);
  const { timeFormat: I, dateFormat: T } = b && a ? B(a, b) : { timeFormat: "HH:mm", dateFormat: "dd/MM/yyyy" };
  return /* @__PURE__ */ i("div", { children: /* @__PURE__ */ i(
    R,
    {
      ref: f,
      required: D,
      selected: t,
      showPopperArrow: !1,
      showTimeSelect: !0,
      dayClassName: (e) => t && r && e.toDateString() === r.toDateString() && t.toDateString() !== r.toDateString() ? "text-brand-primary/50" : "",
      timeClassName: (e) => t && r && e.getTime() === r.getTime() && t.getTime() !== r.getTime() ? "text-brand-primary/50" : ".",
      shouldCloseOnSelect: !1,
      onCalendarClose: () => {
        l(r);
      },
      timeFormat: I,
      dateFormat: T,
      timeIntervals: 15,
      timeCaption: m("public_pages_purchase.date_picker.time"),
      timeInputLabel: m("public_pages_purchase.date_picker.time"),
      onChange: (e) => {
        e && l(e);
      },
      locale: P,
      nextMonthButtonLabel: ">",
      previousMonthButtonLabel: "<",
      popperModifiers: [K(), Q({ padding: 5, crossAxis: !0 })],
      customInput: /* @__PURE__ */ i(
        W,
        {
          error: x,
          label: y,
          required: D,
          wrapperButtonInputClassName: w,
          buttonInputClassName: `flex group justify-between min-w-[250px] w-full py-2.5 px-4 text-sm font-medium text-text-primary border ${x ? "border-danger" : "border-text-secondary/30"} rounded-lg bg-background-secondary focus:outline-hidden focus:border-brand-primary main-transition-colors`,
          description: k,
          labelClassName: C,
          children: () => /* @__PURE__ */ i("span", { children: r ? new Intl.DateTimeFormat(p, {
            day: "2-digit",
            month: "long",
            year: "numeric",
            hour: "numeric",
            hour12: a === s.hourMinuteAmPm || a === s.hourMinuteSecondAmPm,
            minute: "numeric",
            second: a === s.hourMinuteSecond || a === s.hourMinuteSecondAmPm ? "numeric" : void 0
          }).format(r) : /* @__PURE__ */ i("span", { className: "text-text-tertiary/70", children: S }) })
        }
      ),
      renderCustomHeader: ({
        date: e,
        decreaseMonth: N,
        increaseMonth: j,
        prevMonthButtonDisabled: H,
        nextMonthButtonDisabled: O
      }) => /* @__PURE__ */ i(
        U,
        {
          date: e,
          decreaseMonth: N,
          increaseMonth: j,
          prevMonthButtonDisabled: H,
          nextMonthButtonDisabled: O,
          intlLocale: p
        }
      ),
      ..._,
      children: /* @__PURE__ */ L("div", { className: "flex w-full justify-center gap-5 sm:col-span-2", children: [
        /* @__PURE__ */ i(
          V,
          {
            disabled: !t || (d == null ? void 0 : d(t)),
            onClick: () => {
              var e;
              t && ((e = f.current) == null || e.setOpen(!1), u(t), g(J(t)));
            },
            width: "large",
            children: m("public_pages_purchase.date_picker.apply")
          }
        ),
        /* @__PURE__ */ i(
          X,
          {
            onClick: () => {
              var e;
              (e = f.current) == null || e.setOpen(!1), u(null), g(null);
            },
            width: "large",
            children: m("public_pages_purchase.date_picker.clear")
          }
        )
      ] })
    }
  ) });
};
export {
  ce as DateTimePicker
};
